
export const ValidateOrderInput = (order, _createErrorMessage) => {
 if (!order) {
  _createErrorMessage("42");
  return false;
  }

  return true;
};
